import { __awaiter } from "tslib";
import { getDeviceMetadata } from 'pathfinder/utils/sponsoredWidgets/DeviceMetadata';
import { getSponsoredWidgetsByDeviceMetadata, getSponsoredWidgetsByWidgetId, } from 'pathfinder/api/sponsoredWidgets/sponsoredWidget';
import { getMockedHaloEffects } from 'pathfinder/api/sponsoredWidgets/haloEffect';
import { haloEffectTypeToImageSize } from './haloEffectTypeToImageSize';
import { chooseImage } from 'pathfinder/utils/sponsoredWidgets/chooseImage';
import { chooseSponsoredWidgetState } from 'pathfinder/utils/sponsoredWidgets/chooseSponsoredWidgetState';
import { chooseSponsoredWidget } from 'pathfinder/utils/sponsoredWidgets/chooseSponsoredWidget';
export function getHaloEffectBaseData(verticalType, isForced) {
    var _a, _b, _c, _d, _e;
    return __awaiter(this, void 0, void 0, function* () {
        const context = window.SilverSurferSDK.getContext();
        if (!((_a = context === null || context === void 0 ? void 0 : context.user) === null || _a === void 0 ? void 0 : _a.isAnon) || ((_e = (_d = (_c = (_b = window === null || window === void 0 ? void 0 : window.ads) === null || _b === void 0 ? void 0 : _b.context) === null || _c === void 0 ? void 0 : _c.opts) === null || _d === void 0 ? void 0 : _d.noAdsReasons) === null || _e === void 0 ? void 0 : _e.length) > 0) {
            return null;
        }
        const widgetType = 'halo-effect';
        const forcedHaloEffects = isForced
            ? getMockedHaloEffects()
            : yield getSponsoredWidgetsByWidgetId(widgetType);
        const haloEffects = forcedHaloEffects !== null && forcedHaloEffects !== void 0 ? forcedHaloEffects : (yield getSponsoredWidgetsByDeviceMetadata(widgetType));
        if (!haloEffects || !haloEffects.length) {
            return null;
        }
        const device = getDeviceMetadata();
        const chosenHaloEffect = forcedHaloEffects
            ? forcedHaloEffects[0]
            : chooseSponsoredWidget(haloEffects, device, 'halo-effect');
        if (!chosenHaloEffect) {
            return null;
        }
        const sponsoredElementState = chooseSponsoredWidgetState(chosenHaloEffect.states, device, 'halo-effect', chosenHaloEffect.id);
        if (!sponsoredElementState || !sponsoredElementState.navCategories.includes(verticalType)) {
            return null;
        }
        const sponsoredItemImage = chooseImage(sponsoredElementState.images, haloEffectTypeToImageSize(sponsoredElementState.gridLayout), 'halo-effect', null, sponsoredElementState.id);
        if (!sponsoredItemImage) {
            return null;
        }
        return Object.assign(Object.assign({}, sponsoredElementState), { id: chosenHaloEffect.id, imageUrl: sponsoredItemImage.url });
    });
}
